/* *
 *   , Version 2.0 (the "License");
 *     
 *      
 *
 *           
 *
 *  
 * distributed under the License is distributed on an "AS IS" BASIS,
 *  
 *  
 *  
 */

import { objectFromMap } from "../shared/util.js";

class Metadata {
  #metadataMap;

  #data;

  constructor({ parsedData, rawData }) {
    this.#metadataMap = parsedData;
    this.#data = rawData;
  }

  getRaw() {
    return this.#data;
  }

  get(name) {
    return this.#metadataMap.get(name) ?? null;
  }

  getAll() {
    return objectFromMap(this.#metadataMap);
  }

  has(name) {
    return this.#metadataMap.has(name);
  }
}

export { Metadata };
